/* eslint-disable @faire/enforce-internal-folder-encapsulation */
import { FC } from "react";

import { DebugInfoSection } from "../../../ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/DebugInfoSection";
import { FavoriteProps } from "../../../ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import { NotifyMe } from "../../../ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMe";
import { NotifyMeProps } from "../../../ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMeProps";
import { ProductTileOverlay as TileOverlay } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/ProductTileOverlay";
import { ProductTileOverlayProps } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayProps";
import { QuickAddProps } from "../../../ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickViewProps } from "../../../ComposableProductTile/__internal__/__internal__/components/QuickView/QuickViewProps";
import { TopBadges } from "../../../ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadges";
import { TopBadgesProps } from "../../../ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";

import { DebugInfoSectionProps } from "./DebugInfo/DebugInfoSectionProps";
import { Favourite } from "./Favourite";
import { QuickAdd } from "./QuickAdd/QuickAdd";
import { QuickView } from "./QuickView";

export const ProductTileOverlay: FC<{
  productTileQuickViewProps?: QuickViewProps;
  productTileQuickAddProps?: QuickAddProps & { showOnHover: boolean };
  productTileNotifyMeProps?: NotifyMeProps;
  productTileFavoriteProps?: FavoriteProps;
  productTileDebugInfoProps?: DebugInfoSectionProps;
  topBadges?: TopBadgesProps;
  productTileOverlayProps?: ProductTileOverlayProps;
}> = ({
  productTileQuickViewProps,
  productTileQuickAddProps,
  productTileNotifyMeProps,
  productTileFavoriteProps,
  productTileDebugInfoProps,
  topBadges,
  productTileOverlayProps,
}) => {
  return (
    <>
      {productTileQuickViewProps ? (
        <QuickView data={productTileQuickViewProps} />
      ) : null}
      {productTileQuickAddProps ? (
        <QuickAdd data={productTileQuickAddProps} />
      ) : null}
      {productTileNotifyMeProps ? (
        <NotifyMe data={productTileNotifyMeProps} />
      ) : null}
      {productTileFavoriteProps ? (
        <Favourite data={productTileFavoriteProps} />
      ) : null}
      {productTileDebugInfoProps ? (
        <DebugInfoSection data={productTileDebugInfoProps} />
      ) : null}
      {topBadges ? <TopBadges data={topBadges} /> : null}
      {productTileOverlayProps ? (
        <TileOverlay data={productTileOverlayProps} />
      ) : null}
    </>
  );
};
